import { Link } from '@tanstack/react-router';

import MarketingLayout from '@/components/layouts/MarketingLayout';
import { theme } from '@/lib/ui/theme';

/**
 * Branded 404 rendered by the root route's notFoundComponent for any unmatched path.
 */
export function NotFound() {
  return (
    <MarketingLayout>
      <section className="px-6 pt-32 pb-24 text-center md:px-16">
        <div className="mx-auto max-w-[560px]">
          <h1
            className="text-gradient-hero mb-4 text-5xl font-bold md:text-6xl"
            style={{ fontFamily: theme.fonts.display, lineHeight: 1.2 }}
          >
            404
          </h1>
          <p
            className="text-foreground/70 mb-8 text-lg"
            style={{ fontFamily: theme.fonts.body }}
          >
            That page does not exist. It may have moved, or the link may be
            wrong.
          </p>
          <Link
            to="/"
            className="text-foreground/80 hover:text-foreground underline transition-colors"
            style={{ textDecorationColor: theme.colors.semantic.info }}
          >
            Back to home
          </Link>
        </div>
      </section>
    </MarketingLayout>
  );
}
